import { Link, Theme, Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { generateCategoryIcon } from 'common-icons';
import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';

const Categories: FC<React.PropsWithChildren<CategoriesProps>> = ({
  data,
  count = 5,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.categoriesContainer}>
      {data.slice(0, count).map(name => {
        const CatIcon = generateCategoryIcon(name as CategoryDisplayName);
        return (
          <div className={classes.categoryItem} key={name}>
            <Typography
              display='flex'
              alignItems='center'
              variant='body2'
              color='text.primary'
              gap={1}
              fontWeight={400}>
              {CatIcon && <CatIcon className={classes.icon} />}
              {name}
            </Typography>
          </div>
        );
      })}
      {count < data.length && (
        <Tooltip
          arrow
          title={
            <div className={classes.categoriesContainer}>
              {data.slice(count, data.length).map(name => {
                const CatIcon = generateCategoryIcon(
                  name as CategoryDisplayName,
                );
                return (
                  <div className={classes.categoryItem} key={name}>
                    <Typography
                      display='flex'
                      alignItems='center'
                      variant='body2'
                      color='text.primary'
                      gap={1}
                      fontWeight={400}>
                      {CatIcon && <CatIcon className={classes.icon} />}
                      {name}
                    </Typography>
                  </div>
                );
              })}
            </div>
          }>
          <Link
            className={classes.categoryItem}
            variant='body2'
            fontWeight={400}>
            + {data.length - count} more
          </Link>
        </Tooltip>
      )}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  categoriesContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  categoryItem: {
    marginBottom: theme.spacing(0.5),
    alignSelf: 'flex-start',
  },
  small: {
    width: '1em',
    height: '1em',
  },
  icon: {
    color: theme.palette.primary.main,
  },
}));

export interface CategoriesProps {
  data: string[];
  count?: number;
}

export default Categories;
